module.exports = __webpack_public_path__ + "img/module-thumb.a4fe77b6.jpg";